module.exports = __webpack_public_path__ + "icons/original/large/large-d1.4c6fc5e018efe828eb0a0a8136a8cc76.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d1.png
// module id = cgSM
// module chunks = app